import { skipToken } from '@reduxjs/toolkit/query';
import { CommanderAPI } from '../../../../../../../../service/device/CommanderAPI/CommanderAPI';
import { useAppSelector } from '../../../../../../../../redux/store.model';
import { getMyWorkspaceSelector } from '../../../../../../../../redux/workspace/selectors/Workspace.selectors';
import { ITypeRequest } from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';

interface IUseCommanderOfflineProps {
  groupId?: string;
  workspaceId?: string;
  typeRequest: ITypeRequest;
}
function useCommanderOfflineCount(props: IUseCommanderOfflineProps) {
  const { typeRequest, groupId, workspaceId } = props;

  const userDevicesConnectionStatusResponse =
    CommanderAPI.useGetDevicesConnectionStatusCountByUserQuery(undefined, {
      skip: typeRequest !== 'user',
    });

  const groupDevicesConnectionStatusResponse =
    CommanderAPI.useGetDevicesConnectionStatusCountByGroupQuery(
      groupId ?? skipToken,
      {
        skip: typeRequest !== 'group',
      }
    );

  const workspaceDevicesConnectionStatusResponse =
    CommanderAPI.useGetDevicesConnectionStatusCountByWorkspaceQuery(
      workspaceId ?? skipToken,
      {
        skip: typeRequest !== 'workspace',
      }
    );
  const myWorkspace = useAppSelector(getMyWorkspaceSelector);

  const workspacesDevicesConnectionStatusResponse =
    CommanderAPI.useGetDevicesConnectionStatusCountByWorkspaceQuery(
      myWorkspace?.id ?? skipToken,
      {
        skip: typeRequest !== 'workspaces',
      }
    );
  switch (typeRequest) {
    case 'user':
      return userDevicesConnectionStatusResponse;
    case 'group':
      return groupDevicesConnectionStatusResponse;
    case 'workspace':
      return workspaceDevicesConnectionStatusResponse;
    case 'workspaces':
      return workspacesDevicesConnectionStatusResponse;
    default:
      return userDevicesConnectionStatusResponse;
  }
}

export default useCommanderOfflineCount;
